import { identity } from "deso-protocol";
import { useState } from "react";

import { getFocusUser } from "@/backend/focus";
import { createToastErrorDetails } from "@/components/ui/toast-helpers";
import { useToast } from "@/components/ui/use-toast";
import { isIdentityWindowClosedError } from "@/utils/helpers";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  useState(false);
  const { toast } = useToast();

  const login = async () => {
    setLoading(true);

    try {
      const { publicKeyAdded = "" } = await identity.login();
      const account = await getFocusUser(publicKeyAdded).catch(() => null);

      return {
        publicKey: publicKeyAdded,
        account,
      };
    } catch (e) {
      if (isIdentityWindowClosedError(e)) {
        return null;
      }

      toast({
        variant: "destructive",
        title: "Error",
        description: `An error happened when logging in`,
        details: createToastErrorDetails(e),
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    login,
    loading,
  };
};
